import { useCallback, useState } from "react";
import { useIsNewEntry, usePostApi } from "src/hooks";
import { type IFile } from "src/interfaces";
import { useDispatch } from "src/redux/hooks";
import { removeFile } from "src/redux/slices/generatorSlice";
import { openBase64 } from "src/utils";

export const useFileRow = (file: IFile) => {
  const [isLoading, setIsLoading] = useState(false);
  const { post } = usePostApi();
  const dispatch = useDispatch();
  const isNewEntry = useIsNewEntry(false);

  const handleOpen = useCallback(
    async (file: IFile) => {
      if ("b64" in file && file.b64) {
        openBase64(file.b64, file.filetype, file.filename, false);
      } else {
        setIsLoading(true);
        const data = await post({
          request: "view-file",
          body: { params: { aid: file.aid } },
        });
        openBase64(data.data, data.type, data.filename);
        setIsLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
    [file.aid, post],
  );

  const handleRemove = useCallback(async () => {
    await post({
      request: "remove-file",
      body: { params: { aid: file.aid } },
      onSuccess: () => {
        dispatch(removeFile(file.aid));
      },
    });
  }, [dispatch, file.aid, post]);

  return {
    isLoading,
    isNewEntry,
    handleOpen,
    handleRemove,
  };
};
